<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SuppliersList from "@/components/suppliers"

import SuppliersApi from "@/services/suppliers-api";


/**
 * Projects-list component
 */
export default {
  page: {
    title: "Liste des Laboratoires",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout,SuppliersList },
  data() {
    return {
      title: "Liste des Laboratoires",
      allLaboratoriesCount:null,
      type: null ,
    };
  },
  mounted(){
    this.getLaboratoriesCount();
  },
  methods: {
    getLaboratoriesCount(){
      this.type = 0
      SuppliersApi.getCount(this.type).then(
        result => {
          this.allLaboratoriesCount=result;
        }
      )
    },
  }
};
</script>
<template>
  <Layout>
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
        <div class="card border border-primary">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Laboratoires</h2>
            <p class="card-title-desc font-size-14">
              <u><span>{{this.allLaboratoriesCount}}</span> Laboratoires</u> Pharmaceutiques
            </p>

            <div class="pt-3">
              <SuppliersList :isLaboratory=true />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>